import { createContext, ReactNode, useContext, useMemo } from 'react'
import { Workflow } from '@/types/workflows'

type WorkflowLiteContextValue = {
  workflow?: Workflow
}

const WorkflowLiteContext = createContext<WorkflowLiteContextValue>(
  {} as WorkflowLiteContextValue,
)

export const useWorkflowLiteContext = () => useContext(WorkflowLiteContext)

type HoveredTableFieldProviderProps = {
  children: ReactNode
  workflow?: Workflow
}

export default function WorkflowLiteProvider({
  children,
  workflow,
}: HoveredTableFieldProviderProps) {
  const memoizedWorkflow = useMemo(() => workflow, [workflow])
  return (
    <WorkflowLiteContext.Provider value={{ workflow: memoizedWorkflow }}>
      {children}
    </WorkflowLiteContext.Provider>
  )
}
